import React from 'react';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';

const OPERATORS = [
  { value: 'contains', label: 'contains' },
  { value: 'does_not_contain', label: 'does not contain' },
  { value: 'is', label: 'is' },
  { value: 'is_not', label: 'is not' },
];

const DEFAULT_CONDITION = { operator: 'contains', value: '' };

const getFilterValue = (value) => {
  if (value && value.conditions && Array.isArray(value.conditions)) {
    return value;
  }
  return { mode: 'and', conditions: [{ ...DEFAULT_CONDITION }] };
};

const EmailConditionsFilter = ({ value, onChange, column }) => {
  const filterValue = getFilterValue(value);
  const { mode, conditions } = filterValue;

  const emitChange = (updated) => {
    onChange(column, updated);
  };

  const handleModeChange = (e, newMode) => {
    if (newMode) {
      emitChange({ ...filterValue, mode: newMode });
    }
  };

  const handleOperatorChange = (index, operator) => {
    const updated = conditions.map((c, i) => (i === index ? { ...c, operator } : c));
    emitChange({ ...filterValue, conditions: updated });
  };

  const handleValueChange = (index, val) => {
    const updated = conditions.map((c, i) => (i === index ? { ...c, value: val } : c));
    emitChange({ ...filterValue, conditions: updated });
  };

  const handleAddCondition = () => {
    emitChange({
      ...filterValue,
      conditions: [...conditions, { ...DEFAULT_CONDITION }],
    });
  };

  const handleRemoveCondition = (index) => {
    const updated = conditions.filter((_, i) => i !== index);
    if (updated.length === 0) {
      emitChange({ mode: 'and', conditions: [] });
    } else {
      emitChange({ ...filterValue, conditions: updated });
    }
  };

  return (
    <div style={{ minWidth: 340 }}>
      {conditions.length > 1 && (
        <div style={{ marginBottom: 8 }}>
          <ToggleButtonGroup
            value={mode}
            exclusive
            onChange={handleModeChange}
            size="small"
          >
            <ToggleButton value="and" style={{ textTransform: 'none', padding: '2px 12px' }}>
              Match ALL (AND)
            </ToggleButton>
            <ToggleButton value="or" style={{ textTransform: 'none', padding: '2px 12px' }}>
              Match ANY (OR)
            </ToggleButton>
          </ToggleButtonGroup>
        </div>
      )}
      {conditions.map((condition, index) => (
        <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: 6, gap: 6 }}>
          <FormControl style={{ minWidth: 150 }}>
            <Select
              value={condition.operator}
              onChange={(e) => handleOperatorChange(index, e.target.value)}
              displayEmpty
            >
              {OPERATORS.map((op) => (
                <MenuItem key={op.value} value={op.value}>{op.label}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <input
            type="text"
            placeholder="Enter value..."
            value={condition.value || ''}
            onChange={(e) => handleValueChange(index, e.target.value)}
            style={{ flex: 1, padding: '6px 8px', fontSize: 14 }}
          />
          {conditions.length > 1 && (
            <IconButton size="small" onClick={() => handleRemoveCondition(index)} title="Remove condition">
              <span style={{ fontSize: 18, lineHeight: 1 }}>&times;</span>
            </IconButton>
          )}
        </div>
      ))}
      <Button
        size="small"
        onClick={handleAddCondition}
        style={{ textTransform: 'none', marginTop: 4 }}
      >
        + Add Email Condition
      </Button>
    </div>
  );
};

export default EmailConditionsFilter;
